// @flow
import * as React from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import Modal from 'react-modal';
import {BackgroundImage, useImage} from 'components/Image';
import {LayoutLeftTop, LayoutWrapper, useLayoutState} from 'components/Layout';
import {
  LocalizedButton,
  LocalizedParagraph,
  useLocalized,
  type LocalizedText
} from 'components/Localized';
import {ButtonCloseWhite} from 'components/ButtonClose';
import SoundToggleButton from 'components/SoundToggleButton';

import HomeIcon from 'assets/images/driving-zone/btn-index-home.svg';
//import Disclaimer from 'components/Disclaimer'

export type Menu = {
  localText: LocalizedText,
  onClick: () => void,
  active: boolean,
}

export type Action = {
  header: LocalizedText,
  localTexts: Array<LocalizedText>,
  onClick: () => void,
  titles: Array<LocalizedText>,
  buttons: Array<LocalizedText>,
}

export type BaseProps = {
  open: boolean,
  onClose: () => void,
  onOpenModalExteriorColor?: () => void,
}

type Props = BaseProps & {
  titles: Array<LocalizedText>,
  leftMenus: Array<Menu>,
  rightMenu: Action,
  rightMenuOpen?: () => void,
  rightMenuYes?: () => void,
  rightMenuNo?: () => void,
};

export default function ModalIndex(props: Props): React.Element<any> {
  const history = useHistory();
  const layoutState = useLayoutState();
  const localized = useLocalized();
  const [menu, setMenu] = React.useState(-1);
  //const [sound, setSound] = React.useState(true);
  const ImgMenuPoint1 = useImage("./driving-zone/b/img-index-step-full-1.png");
  const ImgMenuPoint2 = useImage("./driving-zone/b/img-index-step-full-2.png");
  const ImgMenuPoint3 = useImage("./driving-zone/b/img-index-step-full-3.png");
  const {onClose} = props;
  const handleClose = React.useCallback(() => {
    setMenu(-1);
    onClose();
  }, [onClose])
  
  return (
    <StyledModal 
      isOpen={props.open}
      contentLabel="Index Modal"
      overlayClassName="modal-overlay"
    >
      <Back />
      <DivRow>
        <DivLeftMenu>
          <LeftMenuWrapper>
            <DivTitle>
              {props.titles.map((value, index) => <LocalizedParagraph {...value} key={index} />)}
            </DivTitle>
            <MenuWrapper id="indexLeftMenuWrapper" source="./driving-zone/b/img-index-step-line.png">
              {props.leftMenus.map((value, index) => <ButtonLeftMenu {...value.localText} key={index} onClick={value.onClick} />)}
              {props.leftMenus.length > 0 && <MenuPoint id="modal-index-play" databackground={layoutState.mobile ? ImgMenuPoint1.imageMobile : ImgMenuPoint1.imageDesktop} datay={layoutState.mobile ? 3 : 6} isHidden={!props.leftMenus[0].active} onClick={props.leftMenus[0].onClick}/>}
              {props.leftMenus.length > 1 && <MenuPoint databackground={layoutState.mobile ? ImgMenuPoint2.imageMobile : ImgMenuPoint2.imageDesktop} datay={layoutState.mobile ? 53 : 106} isHidden={!props.leftMenus[1].active} onClick={props.leftMenus[1].onClick} />}
              {props.leftMenus.length > 2 && <MenuPoint id="modal-index-play3" databackground={layoutState.mobile ? ImgMenuPoint3.imageMobile : ImgMenuPoint3.imageDesktop} datay={layoutState.mobile ? 103 : 206} isHidden={!props.leftMenus[2].active} onClick={props.leftMenus[2].onClick} />}
            </MenuWrapper>
          </LeftMenuWrapper>
        </DivLeftMenu>
        <DivLine />
        <DivRightMenu>
          <div>
          <DivTitle2>
            <LocalizedParagraph {...props.rightMenu.header} />
          </DivTitle2>
          <ButtonRightMenu id="modal-index-gt-line" isHidden={menu >= 0} onClick={() => {
            if (props.rightMenuOpen != null) {
              props.rightMenuOpen();
            }
            setMenu(0); 

          } } >
            {props.rightMenu.localTexts.map((value, index) => <LocalizedParagraph {...value} key={index} />)}
          </ButtonRightMenu>
          <ButtonRightMenu
            id="modal-index-color"
            isHidden={props.onOpenModalExteriorColor === undefined || menu >= 0}
            onClick={props.onOpenModalExteriorColor}
          >
            <LocalizedParagraph {...localized.driving_a01_index_006} />
          </ButtonRightMenu>
          {false && <ButtonRightMenu {...localized.driving_a01_index_007} isHidden={menu >= 0} onClick={() => console.log('reserve_now')} />}
          <ActionPopup1
            open={menu === 0}
            action={props.rightMenu}
            onNo={() => {  
              if (props.rightMenuNo != null) {
                props.rightMenuNo();
              }
              setMenu(-1);
            }}
            onYes={ () => {
              if (props.rightMenuYes != null) {
                props.rightMenuYes();
              }

              props.rightMenu.onClick(); 
            } }
          />
          </div>
        </DivRightMenu>
      </DivRow>
      <ButtonCloseWhite onClose={handleClose} />
      <DivHomeButton>
        <button onClick={() => history.push('/welcome')}><img src={HomeIcon} alt="" /></button>
      </DivHomeButton>
      <SoundToggleButton />
      
    </StyledModal>
  );
}

type PropsActionPopup = {
  open: boolean,
  action: Action,
  onNo: () => void,
  onYes: () => void,
};

function ActionPopup1(props: PropsActionPopup): React.Element<any> {
  return (
    <ActionWrapper open={props.open} databackgroundcolor="#ffffff">
      {props.action.titles.map((value, index) => <LocalizedParagraph {...value} key={index} />)}
      <ButtonActionWrapper databackgroundcolor="#05141f">
        <div>
        {props.action.buttons.length > 0 && <ButtonLeftAction {...props.action.buttons[0]} onClick={props.onNo} />}
        <ButtonActionSpace />
        {props.action.buttons.length > 0 && <ButtonLeftAction {...props.action.buttons[1]} onClick={props.onYes} />}
        </div>
      </ButtonActionWrapper>
    </ActionWrapper>
  );
}

const StyledModal = styled(Modal)`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  pointer-events: auto;
`;

const Back = styled(LayoutWrapper)`
  background-color: rgba(5, 20, 31, 0.9);
`;

const DivRow = styled.div`
  width: calc(100% - ${(props) => (props.theme.layout.mobile ? 0 : 150 * 2)}px);
  height: 100%;
  pointer-events: none;
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;

  padding-left: ${(props) => (props.theme.layout.mobile ? 0 : 150)}px;
  padding-right: ${(props) => (props.theme.layout.mobile ? 0 : 150)}px;

  > div {
    transform: ${(props) => props.theme.layout.scale !== undefined ? `scale(${props.theme.layout.scaleRaw})` : 'initial'};
  }
`;

const DivLine = styled.div`
  width: 1px;
  height: ${props => props.theme.layout.mobile ? 255 : 548}px;
  background-color: #ffffff;
`;

const DivLeftMenu = styled.div`
  width: calc(50% - 1px);
  height: ${props => props.theme.layout.mobile ? 239 : 464}px;
  text-align: center;

  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

const DivTitle = styled.div`
  width: ${props => props.theme.layout.mobile ? 214 : 360}px;
  
  border-bottom: 1px solid #ffffff;

  >:nth-child(1) {
    padding-bottom: 8px;
  }
  >:nth-child(2) {
    padding-bottom: 10px;
  }
`;

const DivTitle2 = styled.div`
  width: ${props => props.theme.layout.mobile ? 214 : 360}px;
  height: ${props => props.theme.layout.mobile ? 43 : 77}px;
  text-align: center;

  >:nth-child(1) {
    padding-top: ${props => props.theme.layout.mobile ? 24 : 32}px;
  }
`;

const MenuWrapper = styled(BackgroundImage)`
  width: ${props => props.theme.layout.mobile ? 134 : 268}px;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: contain;
  padding-left: ${props => props.theme.layout.mobile ? 33 : 67}px;
  margin: 41px 0px ${props => props.theme.layout.mobile ? 29 : 54}px ${props => props.theme.layout.mobile ? 13 : 26}px;
  height: ${props => props.theme.layout.mobile ? 124 : 248}px;
  position: relative;

  >:nth-child(1) {
    position: absolute;
    left: ${props => props.theme.layout.mobile ? 34 : 67}px;
    top: ${props => props.theme.layout.mobile ? 7 : 12}px;
    //margin-bottom: ${props => props.theme.layout.mobile ? 27 : 45}px;
  }
  >:nth-child(2) {
    position: absolute;
    left: ${props => props.theme.layout.mobile ? 34 : 67}px;
    top: ${props => props.theme.layout.mobile ? 57 : 112}px;
    //margin-bottom: ${props => props.theme.layout.mobile ? 30 : 50}px;
  }
  >:nth-child(3) {
    position: absolute;
    left: ${props => props.theme.layout.mobile ? 34 : 67}px;
    top: ${props => props.theme.layout.mobile ? 106 : 213}px;
  }
`;

const MenuPoint = styled.button`
  background-image: url(${props => props.databackground});
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: ${props => props.theme.layout.mobile ? 3 : 6}px;
  top: ${props => props.datay}px;
  width: ${props => props.theme.layout.mobile ? 18 : 36}px;
  height: ${props => props.theme.layout.mobile ? 18 : 36}px;
  opacity: ${(props) => (props.isHidden ? 0 : 1)};
`;

const ButtonLeftMenu = styled(LocalizedButton)`
  min-width: ${props => props.theme.layout.mobile ? 135 : 211}px;
  min-height: ${(props) => (props.theme.layout.mobile ? 14 : 22)}px;
  text-align: left;
  white-space: pre;
`;

const LeftMenuWrapper = styled.div`
  width: 100%;
  //padding: 0 ${(props) => (props.theme.layout.mobile ? 76 : 145)}px;

  display: flex;
  flex-direction: column;
  align-items: center;
  > * {
    pointer-events: auto;
  }
`;

const ActionWrapper = styled.div`
  width: ${(props) => (props.theme.layout.mobile ? 214 - (29 * 2) : 360 - (44 * 2))}px;
  padding: ${(props) => (props.theme.layout.mobile ? 13 : 26)}px ${(props) => (props.theme.layout.mobile ? 29 : 44)}px;
  display: ${(props) => (props.open ? 'inline' : 'none')};
  text-align: center;
  background-color: ${props => props.databackgroundcolor};

  >:nth-child(2) {
    padding-bottom: ${(props) => (props.theme.layout.mobile ? 17 : 23)}px;
  }

  > p {
      word-break: break-word;
  }
`;

const ButtonActionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    width: 100%;
    padding-top: ${props => props.theme.layout.mobile ? 37 : 63}px;
    padding-right: ${props => props.theme.layout.mobile ? 3 : 2}px;
    padding-bottom: ${props => props.theme.layout.mobile ? 0 : 57}px;
    padding-left: ${props => props.theme.layout.mobile ? 3 : 2}px;

    display: flex;
    button {
      background-color: ${props => props.databackgroundcolor};
    }
  }
`;

const ButtonActionSpace = styled.div`
  width: ${props => props.theme.layout.mobile ? 10 : 16}px;
`;

const ButtonLeftAction = styled(LocalizedButton)`
  flex: 1;
  width: ${props => props.theme.layout.mobile ? 70 : 130}px;
  height: ${props => props.theme.layout.mobile ? 32 : 48}px;
`;

const DivRightMenu = styled.div`
  width: 50%;
  height: ${props => props.theme.layout.mobile ? 239 : 464}px;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > * {
      pointer-events: auto;
    }

    > :nth-child(2) {
      margin-top: ${props => props.theme.layout.mobile ? 7 : 10}px;
      margin-bottom: ${props => props.theme.layout.mobile ? 20 : 29}px;
    }

    > :nth-child(3) {
      margin-bottom: 40px;
    }

    > :nth-child(4) {
      background-color: #ffffff;
      margin-bottom: 0px;
    }
  }
`;

const ButtonRightMenu = styled.button`
  width: ${(props) => (props.theme.layout.mobile ? 180 : 360)}px;
  height: ${(props) => (props.theme.layout.mobile ? 46 : 70)}px;
  border: 1px solid #ffffff;
  display: ${(props) => (props.isHidden ? 'none' : 'inline')};
`;


const DivHomeButton = styled(LayoutLeftTop)`
  padding: ${(props) => (props.theme.layout.mobile ? 17 : 47)}px ${(props) => (props.theme.layout.mobile ? 16 : 104)}px;

  > button {
    width: ${(props) => (props.theme.layout.mobile ? 27 : 32)}px;
    height: ${(props) => (props.theme.layout.mobile ? 23 : 26)}px;
  }
`;